
import React,{ useEffect } from 'react';
import Cookies from 'universal-cookie';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
// import MenuItem from '@material-ui/core/MenuItem';
// import Menu from '@material-ui/core/Menu';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
// import FlagIcon from '@material-ui/icons/Flag';
// import DeleteIcon from '@material-ui/icons/Delete';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import cyan from '@material-ui/core/colors/cyan';
import amber from '@material-ui/core/colors/amber';
import { useHistory } from "react-router-dom";

// import red from '@material-ui/core/colors/red';
import axios from 'axios';
// import ReactToPrint from 'react-to-print';
import './Label.css';
import Header from './Header'
const cookies = new Cookies();

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    textAlign: 'center',
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
  menuButton: {
    marginLeft: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },

  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
  },
  busy: {
    textAlign: 'center',
    padding: theme.spacing(2),
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
  }
}));
const theme = createMuiTheme({
  palette: {
    primary: {
      main: amber[200],
    },
    secondary: {
      main: amber[500],
    },
    inherit: {
      main: cyan[200],
    },
  },
});
export default function Card() {
  const history = useHistory();

  // const API_URL = "http://37.139.28.173:5000"
  const API_URL = "https://gw-clubadm.euro-sport.co.il"

  // const API_URL = "http://api.cards.euro-sport.co.il:5000"
  const classes = useStyles();
  const [phone, setPhone] = React.useState(null);
  const [result, setResult] = React.useState(null);
  const [busy, setBusy] = React.useState(false);
  const [worker, setWorker] = React.useState(false);
  const [users, setUsers ] = React.useState(null);
  const get_users = () =>{
    axios
      .post(API_URL + "/get_users")
      .then(function (response) {
	      console.log(response)
        if (response.status === 200) {
          setUsers(response.data.response);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
}

  useEffect(() => { 
    let user = cookies.get('login_user')
    if(user === undefined){
      history.push("/")
    }
    setWorker(user) 
    get_users();

  }, [])
  const handleStart = (event) => {
    // console.log(model)
    // console.log(color)
    // setRunning(true)
    setBusy(true)
    // setResult(null)
    console.log(worker)
    axios.post(API_URL+'/new_invite_sms',{
      user_id:worker.id,phone:phone
    })
    .then(function (response) {
      setBusy(false)
      console.log("🚀 ~ file: Label.js ~ line 116 ~ response", response)
      if(response.status === 200){
        alert("נשלחה הודעת SMS")
      }
      else if(response.status === 422){
        alert("המספר קיים במערכת, נשלחה הודעה חוזרת")
        // setResult(response.data)
      }
        console.log(response.data);
    })
    .catch(function (error) {
        console.log(error);
    });
    setPhone(null)
    // setDetails(event.target.checked);
  };
  const handleCancel = (event) => {
    setPhone(null)
}
    const handlePhone = (event) => {
        setPhone(event.target.value)
    }

  return (
    <ThemeProvider theme={theme}>
    <div className={classes.root}>
      <Header worker={worker} />

        <Paper className={classes.paper}>
            {
            <form className={classes.root} autoComplete="off">
                <div><TextField id="outlined-basic" type="number" InputLabelProps={{ shrink: true }} disabled={busy ? true : false} value={phone ? phone : ''} label="מספר טלפון" required={true} variant="outlined" onChange={handlePhone}/></div>
                {phone && ([
                  
                  <Button variant="contained" color="primary" disabled={busy ? true : false} className={classes.button} onClick={handleStart}>שלח</Button>,
                  <Button variant="contained" color="primary" disabled={busy ? true : false} className={classes.button} onClick={handleCancel}>אפס</Button>
                ])}
            </form>
            }
        </Paper>
        
    </div>
        {/* </div> */}

  </ThemeProvider>
  );
}
